import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

function Toast({ isOpen, onChange, message, variant }) {
    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={10000}
            onClose={(_, reason) => {
                if (reason === 'clickaway') return;
                onChange(false);
            }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            sx={{ zIndex: 10000 }}
        >
            <Alert onClose={() => onChange(false)} severity={variant} variant="filled" sx={{ width: '100%' }}>
                {message || 'エラーが発生しました。再度試してください。'}
            </Alert>
        </Snackbar>
    );
}

export default Toast;
